import WrapperService from "@/modules/core/services/wrapper-service";
import {createPageableParams} from "@/modules/core/services/table-utils";

const API_URL = process.env.VUE_APP_ROOT_API + "/api/v1/customer"
const API_URL_PUBLIC = process.env.VUE_APP_ROOT_API + "/api/v1/public/qrcode";

const serviceName = "Customer-Service: ";

export default class CustomerService {

  static async readAllFromAPI(successF, errorF) {
    await WrapperService.get(API_URL + "/own", null, serviceName, successF, errorF);
  }

  static async readAllSuppliersFromAPI(successF, errorF) {
    await WrapperService.get(API_URL + "/suppliers", null, serviceName, successF, errorF);
  }

  static async readAllPaginatedFromAPI(page, size, search, sort, sortAsc, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, [], []);
    await WrapperService.get(API_URL + "/page", {params: params}, serviceName, successF, errorF);
  }

  static async readFromAPI(customerId, successF, errorF) {
    await WrapperService.get(API_URL + '/' + customerId, null, "Customer-Service: ", successF, errorF);
  }

  static async readScaledDownFromAPI(customerId, successF, errorF) {
    await WrapperService.get(API_URL + "/" + customerId + "/scaled-down", null, "Customer-Service: ", successF, errorF);
  }

  /**
   *  reads customer profile of the logged-in user incl. name/id-list of all customer-descendants
   */
  static async readProfileFromAPI(successF, errorF) {
    await WrapperService.get(API_URL + "/profile", null, "Customer-Service: ", successF, errorF);
  }

  static putProfileToAPI(user, successF, errorF) {
    WrapperService.put(API_URL + "/profile", user, serviceName, successF, errorF);
  }

  static async typeahead(term, supplierOnly, successF, errorF) {
    await WrapperService.get(API_URL + "/typeahead?search=" + encodeURI(term) + "&searchSupplierOnly=" + (supplierOnly === true).toString(), null, "Customer-Service: ", successF, errorF);
  }

  static postToAPI(customer, successF, errorF) {
    WrapperService.post(API_URL, customer, serviceName, successF, errorF);
  }

  static putToAPI(customer, successF, errorF) {
    WrapperService.put(API_URL, customer, serviceName, successF, errorF);
  }

  static deleteFromAPI(customer, successF, errorF) {
    WrapperService.delete(API_URL + "/" + customer.id, serviceName, successF, errorF)
  }

  static uploadLogo(customerId, file, progress, successF, errorF) {
    let formData = new FormData();
    formData.append("logo", file, file.name);
    WrapperService.monitoringPost(API_URL + "/" + customerId + "/upload/logo", formData, serviceName, progress, successF, errorF);
  }

  static async readAddress(id, successF, errorF) {
    await WrapperService.get(API_URL + "/" + id + "/address", null, serviceName, successF, errorF);
  }

  static registerCustomer(customerDto, successF, errorF) {
    WrapperService.post(API_URL + "/register", customerDto, serviceName, successF, errorF);
  }

  static async readAllSubCustomersFromAPI(successF, errorF) {
    await WrapperService.get(API_URL + "/subcustomers", null, serviceName, successF, errorF);
  }

  static async readAllIdNamesFromAPI(successF, errorF) {
    await WrapperService.get(API_URL_PUBLIC + "/customers", null, serviceName, successF, errorF);
  }
}
